import { Fragment } from 'react';

import { EmailTemplateService as Service } from './EmailTemplateService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { useTranslation } from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.emailTemplate');
  const dataKey = 'id';

  const sendTypes = [
    { value: 1, translationKey: 'catalog.emailSendInvoice' },
    { value: 2, translationKey: 'catalog.emailSendConfirmation' },
    { value: 3, translationKey: 'catalog.emailSendAccount' },
    { value: 4, translationKey: 'catalog.emailErrorNotice' },
    { value: 9, translationKey: 'catalog.emailPaymentReminder' }
  ];

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'subject', header: t('catalog.emailSubject'), minWidth: 200, matchMode: 'contains' },
      { field: 'isUse', header: t('catalog.emailUsage'), width: 100, dataType: 'boolean' },
      { field: 'sendType', header: t('catalog.emailBusinessType'), width: 180, filterOptions: sendTypes, dataType: 'fromFilterOptions' },
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { render: renderDialogCrup, create, update, clone } = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      { field: 'subject', header: t('catalog.emailSubject'), required: true, InputTextProps: { maxLength: 100 }, className: 'md:col-12' },
      { field: 'contentEmail', header: '', required: true, type: 'CKEditor', className: 'md:col-12' },
      { field: 'sendType', header: t('catalog.emailBusinessType'), type: 'Dropdown', DropdownProps: { options: sendTypes }, className: 'md:col-6' },
      { field: 'isUse', header: t('catalog.emailUsage'), type: 'Checkbox', className: 'md:col-6 pt-6' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
